// RouteStateProvider.js
import React, { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { resetRouteState } from '@actions/global';

const RouteStateContext = createContext();

const RouteStateProviderBase = ({ children, location }) => {
  const dispatch = useDispatch();
  const routeStateEntries = useSelector((state) => state);

  const shouldReset = (key) => {
    const entry = routeStateEntries.get(key);
    if (!entry || !entry.resetCheck) return false;

    if (typeof entry.resetCheck === 'function') {
      return entry.resetCheck(location);
    } else if (Array.isArray(entry.resetCheck)) {
      return !entry.resetCheck.includes(location.pathname);
    }

    return false;
  };

  useEffect(() => {
    routeStateEntries.forEach((_, key) => {
      if (shouldReset(key)) {
        dispatch(resetRouteState(key));
      }
    });
  }, [location, routeStateEntries, dispatch]);

  return (
    <RouteStateContext.Provider value={{ shouldReset }}>
      {children}
    </RouteStateContext.Provider>
  );
};

RouteStateProviderBase.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  location: PropTypes.object.isRequired,
};

const RouteStateProvider = withRouter(RouteStateProviderBase);
export { RouteStateContext, RouteStateProvider };
